import ActionTypes from "./ActionTypes";

const getSingleAssets = (payload) => {
  return {
    type: ActionTypes.GET_SINGLE_ASSETS,
    payload: payload,
  };
};
const getUploadsAssetColumns = (payload) => {
  return {
    type: ActionTypes.UPLOAD_ASSETE_COLUMNS,
    payload: payload,
  };
};
const resetSingleAssets = () => {
  return {
    type: ActionTypes.RESET_SINGLE_ASSETS,
  };
};
const setAssetStatus = (payload) => {
  return {
    type: ActionTypes.SET_ASSETS_STATUS,
    payload,
  };
};

const getUnlinkAssets = (payload) => {
  return {
    type: ActionTypes.GET_UNLINK_ASSETS,
    payload: payload,
  };
};

const getPendingAssets = (payload) => {
  return {
    type: ActionTypes.GET_PENDING_ASSETS,
    payload: payload,
  };
};

const resetUnlinkAssets = () => {
  return {
    type: ActionTypes.RESET_UNLINK_ASSETS,
  };
};
//Modules
const get_Modules = (payload) => {
  return {
    type: ActionTypes.GET_MODULES,
    payload: payload,
  };
};
const reset_Modules = () => {
  return {
    type: ActionTypes.RESET_MODULES,
  };
};
const getUnlinkModules = (payload) => {
  return {
    type: ActionTypes.GET_UNLINK_MODULES,
    payload: payload,
  };
};
const resetUnlinkModules = () => {
  return {
    type: ActionTypes.RESET_UNLINK_MODULES,
  };
};

const setDltModuleFromAsset = (payload) => {
  return {
    type: ActionTypes.DLT_MODULE_FROM_ASSET,
    payload,
  };
};

//Group Assets
const get_group_assets = (payload) => {
  return {
    type: ActionTypes.GET_GROUP_ASSETS,
    payload: payload,
  };
};
const reset_group_assets = () => {
  return {
    type: ActionTypes.RESET_GROUP_ASSETS,
  };
};
const setAssetGroupStatus = (payload) => {
  return {
    type: ActionTypes.SET_ASSETS_GROUP_STATUS,
    payload,
  };
};

//LORAWAN
const get_loraWan = (payload) => {
  return {
    type: ActionTypes.GET_LORAWAN,
    payload: payload,
  };
};
const reset_loraWan = () => {
  return {
    type: ActionTypes.RESET_LORAWAN,
  };
};

const set_status_of_group_asset = (payload) => {
  return {
    type: ActionTypes.SET_STATUS_OF_GROUP_ASSET,
    payload,
  };
};

const get_license = (payload) => {
  return {
    type: ActionTypes.GET_LICENSE,
    payload,
  };
};
const reset_license = () => {
  return {
    type: ActionTypes.RESET_LICENSE,
  };
};

const group_assets_details = (payload, id) => {
  return {
    type: ActionTypes.GROUP_ASSET_DETAILS,
    payload,
    id,
  };
};

const get_vauto_assets = (payload) => {
  return {
    type: ActionTypes.GET_VAUTO_ASSETS,
    payload: payload,
  };
};

const getGroupVehiclesByGroupID = (payload) => {
  return {
    type: ActionTypes.GET_GROUP_VEHICLES_BY_ID,
    payload,
  };
};

const getVehicleDetail = (payload) => {
  return {
    type: ActionTypes.GET_GROUP_VEHICLE_DETAILS,
    payload,
  };
};

export {
  getSingleAssets,
  getUploadsAssetColumns,
  resetSingleAssets,
  setAssetStatus,
  getUnlinkAssets,
  resetUnlinkAssets,
  get_vauto_assets,
  getGroupVehiclesByGroupID,
  getVehicleDetail,
  getPendingAssets,

  //Modules
  getUnlinkModules,
  resetUnlinkModules,
  get_Modules,
  reset_Modules,
  setDltModuleFromAsset,

  //Group Assets
  get_group_assets,
  reset_group_assets,
  setAssetGroupStatus,
  group_assets_details,

  //lorawan
  get_loraWan,
  reset_loraWan,
  set_status_of_group_asset,
  get_license,
  reset_license,
};
